import styled from 'styled-components';
import { Styling } from '../../../../constants';

const tableRowHeight = 33;

export const Notice = styled.h1`
  margin: ${Styling.DEFAULT_SPACING}px 0;
  font-size: 20px;
  text-align: center;
`;

export const TableWrapper = styled.div`
  max-height: ${tableRowHeight * 11}px;
  overflow-y: auto;
`;
